module.exports = __webpack_public_path__ + "img/icon-white-12.c8631860.svg";